import {CircularProgress, TableRow} from '@material-ui/core';
import React, {CSSProperties} from 'react';
import 'Shared/components/PagedView/Table/TableLoadingRow.sass';

type LoadingRowProps = {
  style: CSSProperties;
};

const LoadingRow = (props: LoadingRowProps) => (
  <TableRow style={props.style} className="loading-row" component="div">
    Loading Additional Results...&nbsp;
    <CircularProgress />
  </TableRow>
);

export default LoadingRow;
